/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-duplicates */
/**
 * Rich Text Editor - Markdown to HTML Sample
 */
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { createElement } from '@syncfusion/ej2-base';
import axios from 'axios';
import { Image, Link, MarkdownEditor, RichTextEditor, Toolbar, QuickToolbar, PasteCleanup, Table, Video, Audio } from '@syncfusion/ej2-react-richtexteditor';
import * as React from 'react';
import { useEffect, useState, useRef } from 'react';
import { DialogUtility } from '@syncfusion/ej2-react-popups';
import { marked } from 'marked';
import { useStateContext } from '../contexts/ContextProvider';

RichTextEditor.Inject(Image, Link, MarkdownEditor, Toolbar, QuickToolbar, PasteCleanup, Table, Video, Audio);
const readBlobAsText = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = (error) => reject(error);
  reader.readAsText(blob);
});

function HTMLFiles({ props }) {
  let mdSource;
  let mdSplit;
  let mdPrint;
  let htmlPreview;
  let defaultRTE;
  let textArea;
  const { mdfile } = props;
  const { REACT_APP_API_ENDPOINT } = process.env;
  // const { REACT_APP_HTTP_API_ENDPOINT } = process.env;
  const rteObj = useRef(null);
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(true);
  let usr = localStorage.getItem('user');
  if (usr) {
    usr = JSON.parse(usr);
  }
  useEffect(() => {
    const fetchData = async () => {
      if (props && mdfile !== '') {
        // const url = `${REACT_APP_API_ENDPOINT}/mddown?md=${mdfile}`;
        const url = `https://api.zackat.com/v1/local/mddown?md=${mdfile}`;
        await axios({
          url,
          method: 'get',
          responseType: 'blob', // important
        })
          .then(async (response) => {
            // Read file
            const mycontent = await readBlobAsText(response.data);
            setValue(mycontent);
            setLoading(false);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    };
    fetchData();
  }, [mdfile]);

  const { boss } = useStateContext();
  // The function to handle the custom print button logic
  async function printMarkdown() {
    const editor = document.getElementById('markdownPreview').ej2_instances[0];
    const markdownContent = editor.value;

    // Use the marked library to convert Markdown to HTML
    // const marked = new Marked();
    const htmlContent = marked.parse(markdownContent);

    // Create a new window or iframe for printing
    // const printWindow = window.open('', '', 'height=600,width=800');
    const printWindow = window.open('', '_blank');

    if (printWindow) {
      printWindow.document.write('<html><head><title>Print</title></head><body>');
      printWindow.document.write(htmlContent);
      printWindow.document.write('</body></html>');
      printWindow.document.close();

      // Wait for content to render, then print
      /*
      printWindow.addEventListener('load', () => {
        printWindow.print();
        printWindow.close();
      });
      */
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 250);
      /*
      printWindow.onload = () => {
        printWindow.print();
        printWindow.close();
      };
      */
    }
  }

  function fullPreview(e) {
    const id = `${defaultRTE.getID()}html-preview`;
    htmlPreview = defaultRTE.element.querySelector(`#${id}`);
    if ((mdSource.classList.contains('e-active') || mdSplit.classList.contains('e-active')) && e.mode) {
      mdSource.classList.remove('e-active');
      mdSplit.classList.remove('e-active');
      mdSource.parentElement.title = 'Preview';
      textArea.style.display = 'block';
      textArea.style.width = '100%';
      htmlPreview.style.display = 'none';
    } else {
      mdSource.classList.add('e-active');
      mdSplit.classList.add('e-active');
      if (!htmlPreview) {
        htmlPreview = createElement('div', { className: 'e-content' });
        htmlPreview.id = id;
        textArea.parentNode.appendChild(htmlPreview);
      }
      if (e.type === 'preview') {
        textArea.style.display = 'none';
        htmlPreview.classList.add('e-pre-source');
        htmlPreview.style.width = '100%';
      } else {
        htmlPreview.classList.remove('e-pre-source');
        textArea.style.width = '50%';
        htmlPreview.style.width = '50%';
      }
      htmlPreview.style.display = 'block';
      htmlPreview.innerHTML = marked((defaultRTE.contentModule.getEditPanel()).value);
      mdSource.parentElement.title = 'Code View';
    }
  }
  function markDownConversion() {
    if (mdSplit.classList.contains('e-active')) {
      const id = `${defaultRTE.getID()}html-preview`;
      htmlPreview = defaultRTE.element.querySelector(`#${id}`);
      htmlPreview.innerHTML = marked((defaultRTE.contentModule.getEditPanel()).value);
    }
  }
  let dialogInstance;
  function dialogClick(f, hdr, content, e) {
    const ok = null;
    dialogInstance = DialogUtility.confirm({
      title: hdr,
      content,
      okButton: ok,
      cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
  }

  const handleSaveButtonClick = () => {
    if (rteObj.current) {
      const content = rteObj.current.value;
      // Logic to save the content
      fetch(`${REACT_APP_API_ENDPOINT}/mdfileup?md=${mdfile}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
        body: content,
      })
        .then((response) => response.json())
        .then((responseJson) => {
          dialogClick('na', 'File Upload', `${responseJson.response}`, null);
        })
        .catch((error) => {
          console.error('This is a catch error', error);
        });
    }
  };

  useEffect(() => {
    if (value && value.length > 0) {
      defaultRTE = new RichTextEditor({
        enableAutoSave: false,
        saveInterval: 5000,
        actionComplete: (e) => {
          if (e.targetItem === 'Maximize' && isNullOrUndefined(e.args)) {
            fullPreview({ mode: true, type: '' });
          } else if (!mdSplit.parentElement.classList.contains('e-overlay')) {
            if (e.targetItem === 'Minimize') {
              textArea.style.display = 'block';
              textArea.style.width = '100%';
              if (htmlPreview) {
                htmlPreview.style.display = 'none';
              }
              mdSplit.classList.remove('e-active');
              mdSource.classList.remove('e-active');
            }
            markDownConversion();
          }
          setTimeout(() => {
            defaultRTE.toolbarModule.refreshToolbarOverflow();
          }, 400);
        },
        created: () => {
          rteObj.current = defaultRTE;
          textArea = defaultRTE.contentModule.getEditPanel();
          textArea.addEventListener('keyup', () => {
            markDownConversion();
          });
          mdSource = document.getElementById('preview-code');
          mdSource.addEventListener('click', (e) => {
            fullPreview({ mode: true, type: 'preview' });
            if (e.currentTarget.classList.contains('e-active')) {
              defaultRTE.disableToolbarItem(['Bold', 'Italic', 'StrikeThrough', '|',
                'Formats', 'OrderedList', 'UnorderedList', '|',
                'CreateLink', 'Image', 'Undo', 'Redo', 'CreateTable']);
              e.currentTarget.parentElement.previousElementSibling.classList.add('e-overlay');
            } else {
              defaultRTE.enableToolbarItem(['Bold', 'Italic', 'StrikeThrough', '|',
                'Formats', 'OrderedList', 'UnorderedList', '|',
                'CreateLink', 'Image', 'Undo', 'Redo', 'CreateTable']);
              e.currentTarget.parentElement.previousElementSibling.classList.remove('e-overlay');
            }
          });
          mdSplit = document.getElementById('MD_Preview');
          mdSplit.addEventListener('click', () => {
            if (defaultRTE.element.classList.contains('e-rte-full-screen')) {
              fullPreview({ mode: true, type: '' });
            }
            mdSource.classList.remove('e-active');
            if (!defaultRTE.element.classList.contains('e-rte-full-screen')) {
              defaultRTE.showFullScreen();
            }
          });
          mdPrint = document.getElementById('preview-print');
          mdPrint.addEventListener('click', (e) => {
            printMarkdown();
          });
          fullPreview({ mode: true, type: 'preview' });
          if (boss && usr && usr.loggedIn) {
            document.getElementById('preview-code').disabled = false;
            document.getElementById('MD_Preview').disabled = false;
            document.getElementById('preview-code-icon').classList.remove('e-disabled');
            document.getElementById('MD_Preview-icon').classList.remove('e-disabled');
          } else {
            defaultRTE.disableToolbarItem(['Bold', 'Italic', 'StrikeThrough', '|',
              'Formats', 'OrderedList', 'UnorderedList', '|',
              'CreateLink', 'Image', 'Undo', 'Redo', 'CreateTable']);
          }
        },
        editorMode: 'Markdown',
        height: '300px',
        toolbarSettings: {
          items: [
            'Bold', 'Italic', 'StrikeThrough', '|', 'Formats', 'OrderedList', 'UnorderedList', '|',
            'CreateLink', 'Image', 'CreateTable', '|',
            {
              template: '<button id="preview-code" class="e-tbar-btn e-control e-btn e-icon-btn" disabled="true">'
                + '<span id="preview-code-icon" class="e-btn-icon e-md-preview e-preview e-icons e-disabled"></span></button>',
              tooltipText: 'Preview',
            },
            {
              template: '<button id="MD_Preview" class="e-tbar-btn e-control e-btn e-icon-btn" disabled="true">'
                + '<span id="MD_Preview-icon" class="e-btn-icon e-view-side e-icons e-disabled" ></span></button>',
              tooltipText: 'Split Editor',
            },
            '|', 'Undo', 'Redo',
            {
              tooltipText: 'Print Markdown',
              template: '<button id="preview-print" class="e-tbar-btn e-control e-btn e-icon-btn">'
                + '<span id="MD_Print-icon" class="e-btn-icon e-print e-icons" ></span></button>',
            },
          ],
        },
        valueTemplate: value,
      });
      if (!loading) {
        defaultRTE.appendTo('#markdownPreview');
      }
    }
  });
  if (loading) {
    return <p>Loading... </p>;
  }
  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh">
      <div id="rte-default" className="control-pane">
        <div className="control-section" id="rtePreview">
          {boss && !loading && (
          // eslint-disable-next-line jsx-a11y/control-has-associated-label
          <button type="button" className="e-btn" onClick={handleSaveButtonClick}>Save&nbsp;
            <span id="md_save" className="e-btn-icon e-save e-icons" />
          </button>
          )}
          <div className="content-wrapper">
            <div id="markdownPreview" />
          </div>
        </div>
      </div>
    </div>
  );
}
export default HTMLFiles;
